import { render } from "./CampaignDashboard.vue?vue&type=template&id=eca5b112"
import script from "./CampaignDashboard.vue?vue&type=script&lang=js"
export * from "./CampaignDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__